export const DEFAULT_TIMEZONE = 'Etc/UTC'

function isValidTimezone(tz: string | null | undefined): tz is string {
  if (!tz) return false
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: tz })
    return true
  } catch {
    return false
  }
}

const TZ_BY_COUNTRY: Record<string, string> = {
  BR: 'America/Sao_Paulo',
  US: 'America/New_York',
  CA: 'America/Toronto',
  MX: 'America/Mexico_City',
  AR: 'America/Argentina/Buenos_Aires',
  CL: 'America/Santiago',
  CO: 'America/Bogota',
  PE: 'America/Lima',
  UY: 'America/Montevideo',
  PY: 'America/Asuncion',
  BO: 'America/La_Paz',
  EC: 'America/Guayaquil',
  VE: 'America/Caracas',
  PT: 'Europe/Lisbon',
  ES: 'Europe/Madrid',
  FR: 'Europe/Paris',
  DE: 'Europe/Berlin',
  IT: 'Europe/Rome',
  GB: 'Europe/London',
  IE: 'Europe/Dublin',
  NL: 'Europe/Amsterdam',
  BE: 'Europe/Brussels',
  CH: 'Europe/Zurich',
  AT: 'Europe/Vienna',
  SE: 'Europe/Stockholm',
  NO: 'Europe/Oslo',
  FI: 'Europe/Helsinki',
  DK: 'Europe/Copenhagen',
  PL: 'Europe/Warsaw',
  CZ: 'Europe/Prague',
  HU: 'Europe/Budapest',
  RO: 'Europe/Bucharest',
  GR: 'Europe/Athens',
  RU: 'Europe/Moscow',
  TR: 'Europe/Istanbul',
  AU: 'Australia/Sydney',
  NZ: 'Pacific/Auckland',
  JP: 'Asia/Tokyo',
  KR: 'Asia/Seoul',
  CN: 'Asia/Shanghai',
  IN: 'Asia/Kolkata',
  ID: 'Asia/Jakarta',
  PH: 'Asia/Manila',
  TH: 'Asia/Bangkok',
  AE: 'Asia/Dubai',
  SA: 'Asia/Riyadh',
  EG: 'Africa/Cairo',
  ZA: 'Africa/Johannesburg',
  NG: 'Africa/Lagos',
  KE: 'Africa/Nairobi',
  MA: 'Africa/Casablanca',
}

export function resolveUserTimezone(country?: string | null): string {
  const code = (country || '').trim().toUpperCase()
  if (code && isValidTimezone(TZ_BY_COUNTRY[code])) {
    return TZ_BY_COUNTRY[code]
  }

  try {
    const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (isValidTimezone(browserTz)) return browserTz
  } catch {
  }

  return DEFAULT_TIMEZONE
}

